import { authClient } from './lib/authClient';
import { Alert, Loader } from '@mantine/core';
import { BadgeAlert } from 'lucide-react';
import { type FC, type ReactNode, useEffect } from 'react';
import { useLocation } from 'wouter';

export const AuthCheck: FC<{ readonly children: ReactNode }> = ({
  children,
}) => {
  const [, navigate] = useLocation();

  const { data: session, error, isPending } = authClient.useSession();

  useEffect(() => {
    if (!isPending && (!session?.session || !session?.user)) {
      navigate('/signin', { replace: true });
    }
  }, [isPending, navigate, session?.session, session?.user]);

  if (isPending) {
    return (
      <Loader
        color="gray"
        size="sm"
        type="dots"
      />
    );
  }

  if (!session?.session || !session?.user) {
    return null;
  }

  if (error) {
    return (
      <Alert
        color="red"
        icon={<BadgeAlert color="red" />}
        m="xl"
        title="Error"
        variant="outline"
      >
        {error?.message || 'Unexpected error occurred. Please try again'}
      </Alert>
    );
  }

  return children;
};
